import request from '@/axios'

export function getFiltersAndFields (query, tableName, customer_id, portal_type = 'STAFF') {
  return request({
    url:`/filter/platform_fields/${query}/${tableName}/${customer_id}/${portal_type}`,
    method:'GET'
  })
}

export function getMainFilterList (query, customer_type, tableName) {
  return request({
    url:`/filter/list_filter/${query}/${tableName}/${customer_type}`,
    method:'GET'
  })
}

export function createNewFilter  (payload) {
  return request({
    url:'/filter/create_filters',
    method:'POST',
    data:payload

  })
}

export function getFilterList (query) {
  return request({
    url:`filter/filterlist/${query}`,
    method:'GET'
  })
}


export function getAllFilterListOfModule (query, customer_type, payload) {
  return request({
    url:`filter/filter_list_value/${query}/${customer_type}`,
    method:'POST',
    data:payload
  })
}

export function deleteFilterMain (query) {
  return request({
    url:`filter/delete_filter/${query}`,
    method:'GET'
  })
}
